import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home'
import Score from '../views/Score'
// import Sportsbook from "../views/SportsbookTest";
import Sportsbook from "../views/Sportsbook";
import InPlay from "../views/SportsbookV2";
import SportMaintenance from "../views/SportMaintenance.vue";
// import Live from '../views/LiveTest'
import Live from '../views/Live'
import Casino from '../views/Games/Casino'
import Slot from '../views/Games/Slot'
import Beton from '../views/Games/Beton'
import Poker from '../views/Games/Poker'
import Highflyer from '../views/Games/Highflyer'
import Binary from '../views/Games/Binary'
import Aviator from '../views/Games/Aviator'
import Zeppelin from '../views/Games/Zeppelin'
import Virtual from '../views/Games/Virtual'
import Bingo from '../views/Games/Bingo'
import Wheel from '../views/Games/Wheel'
import Promotions from '../views/Promotions'
import Auth from '../views/Auth/index'
import Register from '../views/Auth/Register'
import ForgotPassword from "../views/Auth/Forgot/Password";
import NewPassword from "../views/Auth/Forgot/NewPassword";
import EmailPending from "../views/Auth/EmailPending";
import EmailCode from "../views/Auth/EmailCode";
import EmailVerifyV2 from "../views/Auth/EmailVerifyV2";
import EmailVerify from "../views/Auth/EmailVerify";
import Login from '../views/Auth/Login'
import G2faLogin from '../views/Auth/G2fa'
import User from '../views/User/index'
import Page from '../views/Page'
import Affiliate from '../views/Affiliate'
import NotFound from '../views/Errors/404'
import Maintenance from '../views/Errors/Maintenance'
import LoginAdmin from '../views/Auth/LoginAdmin'

import store from '../store'

Vue.use(VueRouter)

const routes = [
  {
    path: "/",
    redirect: "/home",
  },
  {
    path: "/home",
    name: "Homepage",
    component: Home,
    meta: {
      auth: false,
      KeepAlive: true,
      g2fa: true,
      pageName: 'Homepage'
    }
  },
  {
    path: "/sportmaintenance",
    name: "SportMaintenance",
    component: SportMaintenance,
    meta: {
      auth: true,
      KeepAlive: true,
      g2fa: true,
      pageName: 'SportMaintenance'
    }
  },
  {
    path: "/inplay",
    name: "InPlay",
    component: InPlay,
    meta: {
      auth: true,
      KeepAlive: true,
      g2fa: true,
      pageName: 'InPlay'
    }
  },
  {
    path: "/sportsbook",
    name: "Sportsbook",
    component: Sportsbook,
    meta: {
      auth: false,
      KeepAlive: false,
      g2fa: false,
      pageName: 'Upcoming'
    }
  },
  {
    path: "/live",
    name: "Live",
    component: Live,
    meta: {
      auth: false,
      KeepAlive: false,
      g2fa: false,
      pageName: 'Live'
    }
  },
  {
    path: "/affiliate",
    name: "Affiliate",
    component: Affiliate,
    meta: {
      auth: false,
      KeepAlive: true,
      g2fa: true,
      pageName: 'Promotions'
    }
  },
  {
    path: "/poker",
    name: "Poker",
    component: Poker,
    meta: {
      auth: true,
      KeepAlive: true,
      g2fa: true,
      pageName: 'Poker'
    }
  },
  {
    path: "/page/:slug",
    name: "Page",
    component: Page,
    meta: {
      auth: false,
      KeepAlive: true,
      g2fa: true
    }
  },
  {
    path: "/score",
    name: "Score",
    component: Score,
    meta: {
      auth: false,
      KeepAlive: true,
      g2fa: true
    }
  },
  {
    path: "/casino/:provider?/:category?",
    name: "Casino",
    component: Casino,
    meta: {
      auth: false,
      KeepAlive: true,
      g2fa: true,
      pageName: 'Casino'
    }
  },
  {
    path: "/wheel",
    name: "Wheel",
    component: Wheel,
    meta: {
      auth: false,
      KeepAlive: true,
      g2fa: true
    }
  },
  {
    path: "/slot/:provider?/:category?",
    name: "Slot",
    component: Slot,
    meta: {
      auth: false,
      KeepAlive: true,
      g2fa: true,
      pageName: 'Slot'
    }
  },
  {
    path: "/beton",
    name: "Beton",
    component: Beton,
    meta: {
      auth: true,
      KeepAlive: true,
      g2fa: true,
      pageName: 'BetON'
    }
  },
  {
    path: "/bingo",
    name: "Bingo",
    component: Bingo,
    meta: {
      auth: true,
      KeepAlive: true,
      g2fa: true,
      pageName: 'Bingo'
    }
  },
  {
    path: "/zeppelin",
    name: "Zeppelin",
    component: Zeppelin,
    meta: {
      auth: true,
      KeepAlive: true,
      g2fa: true
    }
  },
  {
    path: "/highflyer",
    name: "Highflyer",
    component: Highflyer,
    meta: {
      auth: true,
      KeepAlive: true,
      g2fa: true
    }
  },
  {
    path: "/binary",
    name: "Binary",
    component: Binary,
    meta: {
      auth: true,
      KeepAlive: true,
      g2fa: true
    }
  },
  {
    path: "/aviator",
    name: "Aviator",
    component: Aviator,
    meta: {
      auth: true,
      KeepAlive: true,
      g2fa: true
    }
  },
  {
    path: "/virtual/:provider?",
    name: "Virtual",
    component: Virtual,
    meta: {
      auth: false,
      KeepAlive: true,
      g2fa: true,
      pageName: 'Virtual'
    }
  },
  {
    path: "/promotions/:group?/:id?",
    name: "Promotions",
    component: Promotions,
    meta: {
      auth: false,
      KeepAlive: true,
      g2fa: true,
      pageName: 'Promotions'
    }
  },
  {
    path: "/user/:section/:payment?",
    name: "User",
    component: User,
    meta: {
      auth: true,
      KeepAlive: false,
      g2fa: true
    }
  },
  {
    path: "/maintenance",
    name: "Maintenance",
    component: Maintenance,
    meta: {
      auth: false,
      KeepAlive: true,
      g2fa: false
    }
  },
  {
    path: '*',
    name: 'NotFound',
    component: NotFound
  },
  {
    path: "/auth",
    redirect: "/auth/register",
    name: "Auth",
    component: Auth,
    children: [
      {
        path: "register",
        name: "Register",
        component: Register,
        meta: {
          auth: false,
          guest: true,
          g2fa: true,
          pageName: 'Register'
        }
      },
      {
        path: "login",
        name: "Login",
        component: Login,
        meta: {
          auth: false,
          guest: true,
          g2fa: false,
          pageName: 'Login'
        }
      },
      {
        path: "login-admin",
        name: "LoginAdmin",
        component: LoginAdmin,
        meta: {
          auth: false,
          guest: false,
          g2fa: false,
          pageName: 'LoginAdmin'
        }
      },
      {
        path: "g2fa",
        name: "G2faLogin",
        component: G2faLogin,
        meta: {
          auth: true,
          g2fa: false,
          pageName: 'Login'
        }
      },
      {
        path: "forgot-password",
        name: "ForgotPassword",
        component: ForgotPassword,
        meta: {
          guest: true,
        }
      },
      {
        path: "new-password",
        name: "NewPassword",
        component: NewPassword,
        meta: {
          auth: false,
          g2fa: true
        }
      },
      {
        path: "email-verify",
        name: "EmailVerify",
        component: EmailVerify,
        meta: {
          auth: false,
          g2fa: true
        }
      },
      {
        path: "verification/email-pending",
        name: "EmailPending",
        component: EmailPending,
        meta: {
          auth: false,
          g2fa: false
        }
      },
      {
        path: "verification/email-code",
        name: "EmailCode",
        component: EmailCode,
        meta: {
          auth: false,
          g2fa: false
        }
      },
      {
        path: "verification/email",
        name: "EmailVerifyV2",
        component: EmailVerifyV2,
        meta: {
          auth: false,
          g2fa: false
        }
      }
    ]
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  linkActiveClass: "active",
  routes
});

const auth = {
	g2fa(){
		return store.getters['auth/isG2fa']
  },
	loggedIn() {
		return store.getters['auth/isLoggedIn']
  },
  detail(){
    return store.getters['auth/user_detail']
  }
}

router.beforeEach((to, from, next) => {

  
  let authRequired = false
	if(to && to.meta && to.meta.auth)
    authRequired = true

  let guestRequired = false
  if(to && to.meta && to.meta.guest)
    guestRequired = true
    
  let g2faRequired = false
  if(to && to.meta && to.meta.g2fa)
    g2faRequired = true

  if (guestRequired && auth.loggedIn())
  {
    router.push({name: 'Homepage'});
    return;
  }

  if (authRequired && !auth.loggedIn() && to.name !== 'Login')
  {
    router.push({name: 'Login'});
    return;
  }

  if (g2faRequired && !auth.g2fa()) 
  {
    router.push({name: 'G2faLogin'});
    return;
  }

  if (auth.g2fa() && to.name === 'G2faLogin')
	{
		router.push({name: 'Homepage'});
		return;
  }

  
  if (auth.loggedIn() && auth.detail()){

    if(to.path !== '/user/info' && !_.isUndefined(auth.detail().detail.validations.detail) && !_.isUndefined(auth.detail().detail.validations.detail.r) && auth.detail().detail.validations.detail.r == 1 && auth.detail().detail.validations.detail.s != 1){
        router.push({ name : 'User', params:{ section: 'info' } });
        return;
    }

    if(to.path !== '/user/security' && to.path !== '/auth/email-verify' && !_.isUndefined(auth.detail().detail.validations.email) && !_.isUndefined(auth.detail().detail.validations.email.r) && auth.detail().detail.validations.email.r == 1 && auth.detail().detail.validations.email.s != 1){
      router.push({ name : 'User', params:{ section: 'security' } });
      return;
    }
    
    if(to.path !== '/user/security' && !_.isUndefined(auth.detail().detail.validations.phone) && !_.isUndefined(auth.detail().detail.validations.phone.r) && auth.detail().detail.validations.phone.r == 1 && auth.detail().detail.validations.phone.s != 1){
      router.push({ name : 'User', params:{ section: 'security' } });
      return;
    }

    if(to.path !== '/user/documents' && !_.isUndefined(auth.detail().detail.validations.document) && !_.isUndefined(auth.detail().detail.validations.document.r) && auth.detail().detail.validations.document.r == 1 && auth.detail().detail.validations.document.s != 1){
      router.push({ name : 'User', params:{ section: 'documents' } });
      return;
    }

    if(to.path !== '/user/messages' && !_.isUndefined(auth.detail().group_id) && auth.detail().group_id == 9999){
      router.push({ name : 'User', params:{ section: 'messages' } });
      return;
    }

  }

  next();
})


export default router
